(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vd-announcement"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAnnouncement(el) {
    if (el.dataset.vdAncReady) return;
    el.dataset.vdAncReady = '1';
    if (!el.hasAttribute('data-vd-anc-dismissible')) return;

    var id = el.getAttribute('data-vd-anc-id') || 'default';
    var key = 'vd-anc-dismissed:' + id;

    try {
      if (window.sessionStorage && sessionStorage.getItem(key) === '1') {
        el.setAttribute('hidden', '');
        return;
      }
    } catch (e) {}

    var closeBtn = el.querySelector('[data-vd-anc-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        el.setAttribute('hidden', '');
        try { if (window.sessionStorage) sessionStorage.setItem(key, '1'); } catch (e) {}
      });
    }
  }

  function boot() {
    var bars = document.querySelectorAll('[data-vd-anc]');
    for (var i = 0; i < bars.length; i++) initAnnouncement(bars[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vd-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHeader(scope) {
    var header = scope.querySelector('[data-vd-hdr]');
    var drawerRoot = scope.querySelector('[data-vd-drawer-root]');

    /* ---- Scrolled state ---- */
    if (header && header.classList.contains('vd-hdr--sticky') && !header.dataset.vdScrollReady) {
      header.dataset.vdScrollReady = '1';
      var onScroll = function () {
        if (window.pageYOffset > 6) header.classList.add('is-scrolled');
        else header.classList.remove('is-scrolled');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ---- Mobile drawer ---- */
    if (!drawerRoot || drawerRoot.dataset.vdDrawerReady) return;
    drawerRoot.dataset.vdDrawerReady = '1';

    var openBtn = scope.querySelector('[data-vd-drawer-open]');
    var panel = drawerRoot.querySelector('.vd-drawer__panel');
    var lastFocus = null;

    function open() {
      drawerRoot.classList.add('is-open');
      document.documentElement.classList.add('vd-no-scroll');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      lastFocus = document.activeElement;
      var first = drawerRoot.querySelector('.vd-drawer__close');
      if (first) { try { first.focus(); } catch (e) {} }
    }

    function close() {
      drawerRoot.classList.remove('is-open');
      document.documentElement.classList.remove('vd-no-scroll');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus(); } catch (e) {}
      }
    }

    if (openBtn) openBtn.addEventListener('click', open);

    var closers = drawerRoot.querySelectorAll('[data-vd-drawer-close]');
    for (var i = 0; i < closers.length; i++) {
      closers[i].addEventListener('click', close);
    }

    /* ESC to close */
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && drawerRoot.classList.contains('is-open')) {
        close();
      }
    });

    /* Outside-click (overlay) already wired via data-vd-drawer-close;
       guard panel clicks from bubbling to overlay isn't needed since overlay is a sibling. */

    /* Expandable sub-items */
    var toggles = drawerRoot.querySelectorAll('[data-vd-drawer-submenu]');
    for (var t = 0; t < toggles.length; t++) {
      toggles[t].addEventListener('click', function () {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    }
  }

  function boot() {
    initHeader(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var target = (e && e.target) ? e.target : document;
    initHeader(target.querySelector ? target : document);
    initHeader(document);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
